export default {"src":"/_next/static/media/check.636e5546.svg","height":8,"width":12};